import './SignupSuccess.css';
import logo from '../../assets/images/logo.svg';
import extension from '../../assets/images/extension.svg';
import robot from '../../assets/images/robot.png';
import { useNavigate } from 'react-router-dom';

const SignupSuccess = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const navigate = useNavigate();
    return (
        <div className='signupSuccess'>
            <div className='py-32 d-flex justify-content-between'>
                <img src={logo} alt="logo" />
                <div>
                    <ul>
                        <li className='color-sky' onClick={() => navigate('/')}>Back to Website</li>
                        <li className='color-sky'>Need Help?</li>
                    </ul>
                </div>
            </div>
            <div className='content'>
                <div className='content-left'>
                    <h2>You’re in, {userInfo?.FirstName}</h2>
                    <p className='font-16'>Thank you for signing up. We’ve sent a confirmation email to ({userInfo?.Email}). Once verified, you can log in or install the Brainyagent plugin to get started. </p>
                    <div className='d-flex gap-8'>
                        {/* <button className='theme-sky-btn w-fit-content' onClick={() => navigate('/login')}>Log In to Brainyagent</button> */}
                        <button className='theme-outline-btn w-fit-content' onClick={() => navigate('/confirm-signup', { state: { email: userInfo?.Email } })}>Verify</button>
                    </div>
                </div>
                <div className='content-right'>
                    <div className='rectangle'>
                        <div className='circle-top'></div>
                        <div className='circle-bottom'></div>
                        <div className='robot'><img src={robot} alt="robot" /></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SignupSuccess
